import { IEvaluationItemType } from "models/Bid/EvaluationItemTypeModel";
import { BaseService } from "./base.service";

class EvaluationItemTypeServiceInternal extends BaseService {
	getEvaluationItemTypeList = async (): Promise<IEvaluationItemType[]> =>
		this.callApi<IEvaluationItemType[]>(
			`EvaluationItemType/GetEvaluationItemTypeList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const EvaluationItemTypeService =
	new EvaluationItemTypeServiceInternal();
